import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import { updateRegistrationAccountValidation } from "../../../redux/slices/registrationAccountSlice";
import { selectAlias } from "../../../redux/slices/p2pSettingsSlice";
import {
    selectAllEmailVerification,
    updateLastVerifiedEmail,
    updateEmailVerificationInFlight,
    updateEmailHasBeenVerified,
    updateEmailExistsInCurrentRegistration,
    updateEmailExistsInPreviousRegistration,
    updateScrollToEmailField,
    updateYourFundraisingDashboard,
} from "../../../redux/slices/emailVerificationSlice";
import EmailRegistrationField from "./EmailRegistrationField";

const ConnectedEmailRegistrationField = ({
    emailDescriptionText,
    emailLabel,
    emailOptional,
}) => {
    const { registrations, currentRegistration } = useSelector(
        selectAllRegistration,
    );
    const alias = useSelector(selectAlias);
    const emailVerification = useSelector(selectAllEmailVerification);

    const emailRegistrationFieldProps = {
        registrations,
        alias,
        currentRegistration,
        updateRegistrationAccountValidation,
        emailDescriptionText,
        emailLabel,
        emailOptional,
        emailVerification,
        updateLastVerifiedEmail,
        updateEmailVerificationInFlight,
        updateEmailHasBeenVerified,
        updateEmailExistsInCurrentRegistration,
        updateEmailExistsInPreviousRegistration,
        updateScrollToEmailField,
        updateYourFundraisingDashboard,
    };
    return <EmailRegistrationField {...emailRegistrationFieldProps} />;
};

ConnectedEmailRegistrationField.propTypes = {
    emailDescriptionText: PropTypes.string.isRequired,
    emailLabel: PropTypes.string.isRequired,
    emailOptional: PropTypes.bool.isRequired,
};

export default ConnectedEmailRegistrationField;
